import React from 'react';
import { agentIcon } from '../../../types/iconRegistry';

// One agent row in the timeline (T7.5): label gutter + hour lane where the
// draggable block renders.
function TimelineRow({ job, children }) {
  const AgentIcon = agentIcon(job.agentIcon);

  return (
    <div className="timeline-row">
      <div className="timeline-label">
        <span className="timeline-label-icon"><AgentIcon /></span>
        <div>
          <strong>{job.agentName}</strong>
          <span>{job.title}</span>
        </div>
      </div>
      <div className="timeline-lane" data-lane={job.id}>
        {children}
      </div>
    </div>
  );
}

export default TimelineRow;
